<template>
    <div class="contact-campanii">
        <DxDataGrid :data-source="dsMembers" :allowColumnReordering="true" :allowColumnResizing="true" key-expr="ID"
            :columnAutoWidth="false" :columnResizingMode="'nextColumn'" :show-borders="true"
            :syncLookupFilterValues="false" :filter-sync-enabled="true" :show-column-lines="false"
            :hover-state-enabled="true" :remote-operations="true" class="grid theme-dependent">

            <DxSelection mode="single" />
            <DxPaging :page-size="10" />
            <DxFilterRow :visible="true" />
            <DxHeaderFilter :visible="false" />
            <DxLoadPanel :enabled="true" />
            <DxSearchPanel :visible="true" placeholder="Caută membru..." />
            <DxEditing :allow-deleting="true" />

            <DxGridToolbar>

                <DxGridToolbarItem location="after">
                    <DxButton icon="plus" type="default" text="Adaugă Membri" @click="onOpenContactPicker" />
                </DxGridToolbarItem>
                <DxGridToolbarItem location="after">
                    <DxButton icon="email" type="success" text="Lansează Trimitere" @click="onLaunchCampaign" />
                </DxGridToolbarItem>
            </DxGridToolbar>

            <DxColumn data-field="Contact.Nume" cell-template="contactTemplate" caption="Nume Contact" />
            <template #contactTemplate="{ data }">
                <div class="contact-cell">
                    <i class="dx-icon-user"></i>
                    <span class="contact-name">{{ data.data.Contact?.Nume }} {{ data.data.Contact?.Prenume }}</span>
                </div>
            </template>

            <DxColumn data-field="Contact.Account.Nume" caption="Partener" />
            <DxColumn data-field="Contact.TelMobil" caption="Telefon" />
            <DxColumn data-field="Contact.Email" caption="Email" />
            <DxColumn data-field="DataAdaugarii" caption="Data Adăugării" data-type="date" format="dd/MM/yyyy" />
            <DxColumn data-field="StatusTrimitere" caption="Status" cell-template="statusTemplate" />
            <template #statusTemplate="{ data }">
                <span :class="'status-badge-' + data.value">
                    {{ data.value === 0 ? 'În așteptare' : (data.value === 1 ? 'Trimis' : 'Eroare') }}
                </span>
            </template>
            <DxColumn data-field="DataTrimitere" caption="Data Trimiterii" data-type="date" format="dd/MM/yyyy HH:mm" />

        </DxDataGrid>

        <DxPopup v-model:visible="isContactPickerVisible" :width="900" :height="700" :show-close-button="true"
            @showing="onPickerShowing" :drag-enabled="true" position="center" class="premium-popup">
            <template #title>
                <div class="premium-popup-header">
                    <div class="header-icon-wrapper">
                        <i class="dx-icon-group"></i>
                    </div>
                    <div class="header-text">
                        <span class="header-title">Selectează Membri Campanie</span>
                        <span class="header-subtitle">Alege contactele eligibile pentru această campanie
                            marketing</span>
                    </div>
                </div>
            </template>

            <div class="picker-main-container">
                <div class="picker-grid-wrapper">
                    <DxDataGrid :data-source="dsAllContacts" :allowColumnReordering="true" :allowColumnResizing="true"
                        key-expr="ID" :columnAutoWidth="true" :show-borders="false" :syncLookupFilterValues="false"
                        :filter-sync-enabled="true" :show-column-lines="false" :hover-state-enabled="true"
                        :remote-operations="true" height="500" class="picker-grid modern-grid"
                        @selection-changed="onSelectionChanged">
                        <DxSelection mode="multiple" show-check-boxes-mode="always" />
                        <DxFilterRow :visible="true" />
                        <DxSearchPanel :visible="true" placeholder="Caută după nume, partener sau email..." />
                        <DxPaging :page-size="10" />

                        <DxColumn data-field="Nume" cell-template="contactNameTemplate" />
                        <DxColumn data-field="Account.Nume" caption="Partener" cell-template="companyTemplate" />

                        <DxColumn data-field="EmailMarketing" caption="Email" data-type="boolean" width="80"
                            cell-template="mktTemplate" alignment="center" />
                        <DxColumn data-field="SmsMarketing" caption="SMS" data-type="boolean" width="80"
                            cell-template="mktTemplate" alignment="center" />

                        <template #contactNameTemplate="{ data }">
                            <div class="picker-contact-cell">
                                <div class="contact-avatar-small">{{ (data.data.Nume?.[0] || '') +
                                    (data.data.Prenume?.[0]
                                        || '') }}</div>
                                <div class="contact-name-info">
                                    <span class="primary-name">{{ data.data.Nume }} {{ data.data.Prenume }}</span>
                                    <span class="secondary-info">{{ data.data.TelMobil || 'Fara telefon' }}</span>
                                </div>
                            </div>
                        </template>

                        <template #companyTemplate="{ data }">
                            <div class="company-cell-info">
                                <i class="dx-icon-home"></i>
                                <span>{{ data.data.Account?.Nume || '-' }}</span>
                            </div>
                        </template>

                        <template #mktTemplate="{ data }">
                            <div class="mkt-consent-wrapper">
                                <v-icon v-if="data.value" color="success" size="20">mdi-check-decagram</v-icon>
                                <v-icon v-else color="grey-lighten-1" size="20">mdi-minus-circle-outline</v-icon>
                            </div>
                        </template>
                    </DxDataGrid>
                </div>

                <div class="picker-footer-modern">
                    <div class="selection-info">
                        <div v-if="selectedContactIds.length > 0" class="selection-pill animate-in">
                            <v-icon color="white" size="16" class="mr-2">mdi-account-check</v-icon>
                            <span>{{ selectedContactIds.length }} contacte selectate</span>
                        </div>
                        <span v-else class="no-selection-text">Selectează contacte din listă pentru a le adăuga în
                            campanie</span>
                    </div>
                    <div class="footer-buttons">
                        <DxButton text="Anulează" styling-mode="outlined" type="normal"
                            @click="isContactPickerVisible = false" class="modern-btn" />
                        <DxButton text="Adaugă în Campanie" type="success" @click="addSelectedContacts" width="210"
                            :disabled="!selectedContactIds.length" class="modern-btn primary-btn" icon="plus" />
                    </div>
                </div>
            </div>
        </DxPopup>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import {
    DxDataGrid,
    DxColumn,
    DxSelection,
    DxPaging,
    DxFilterRow,
    DxHeaderFilter,
    DxLoadPanel,
    DxSearchPanel,
    DxEditing,
    DxToolbar as DxGridToolbar,
    DxItem as DxGridToolbarItem
} from 'devextreme-vue/data-grid';
import { DxButton } from 'devextreme-vue/button';
import DxPopup from 'devextreme-vue/popup';
import ODataStore from 'devextreme/data/odata/store';
import DataSource from 'devextreme/data/data_source';
import AppSetting from '@/settings/appSettings';
import notify from 'devextreme/ui/notify';
import { confirm } from 'devextreme/ui/dialog';
import CrmCampaniiMarketing from '@/services/Comercial/CrmCampaniiMarketing';

export default defineComponent({
    name: 'ContactCampanii',
    components: {
        DxDataGrid, DxColumn, DxSelection, DxPaging, DxFilterRow, DxHeaderFilter, DxLoadPanel, DxSearchPanel,
        DxEditing, DxGridToolbar, DxGridToolbarItem, DxButton, DxPopup
    },
    props: {
        campaignId: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            dsMembers: {} as ODataStore,
            dsAllContacts: {} as ODataStore,
            isContactPickerVisible: false,
            selectedContactIds: [] as string[],
        };
    },
    methods: {
        createODataContext() {
            this.dsMembers = new DataSource({
                store: new ODataStore({
                    url: AppSetting.API_Url_ComercialOdata + 'CRM_CampaniiMembri',
                    key: 'ID',
                    keyType: 'Guid',
                    version: 4,
                    fieldTypes: {
                        'ID': 'Guid',
                        'CampanieID': 'Guid',
                        'ContactID': 'Guid'
                    },
                    beforeSend: (e) => {
                        e.headers = {
                            "Content-Type": "application/json",
                            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt"),
                        };
                        // Move expand back here for stability
                        e.params.$expand = "Contact($expand=Account($select=Nume))";
                    }
                }),
                filter: ['CampanieID', '=', this.campaignId]
            });
            this.dsAllContacts = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_ComercialOdata + 'CRM_Contacts',
                    key: 'ID',
                    keyType: "Guid",
                    version: 4,

                    beforeSend: (e: any) => {

                        e.headers = {
                            "Content-Type": "application/json",
                            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")

                        };
                    }
                },
                select: [
                    'ID',
                    'Nume',
                    'Prenume',
                    'Account.Nume',
                    'TelMobil',
                    'Email',
                    'EmailMarketing',
                    'SmsMarketing'
                ],
                filter: [['EmailMarketing', '=', true], 'or', ['SmsMarketing', '=', true]]

            });
        },
        onSelectionChanged(e: any) {
            this.selectedContactIds = e.selectedRowKeys;
        },
        async addSelectedContacts() {
            try {
                const membersStore = (this.dsMembers.store() as any);
                const currentMembers = this.dsMembers.items();
                const existingContactIds = currentMembers.map((m: any) => m.ContactID);

                const newContactsToAdd = this.selectedContactIds.filter(id => !existingContactIds.includes(id));

                if (newContactsToAdd.length === 0) {
                    notify("Toate contactele selectate sunt deja membre ale campaniei.", "warning", 3000);
                    this.isContactPickerVisible = false;
                    return;
                }

                for (const contactId of newContactsToAdd) {
                    await membersStore.insert({
                        CampanieID: this.campaignId,
                        ContactID: contactId,
                        DataAdaugarii: new Date(),
                        StatusTrimitere: '0'
                    });
                }
                notify(`${newContactsToAdd.length} membri au fost adăugați cu succes!`, "success", 2000);
                this.isContactPickerVisible = false;
                this.selectedContactIds = [];
                this.dsMembers.reload();
            } catch (error) {
                console.error("Error adding members:", error);
                notify("Eroare la adăugarea membrilor!", "error", 2000);
            }
        },
        onOpenContactPicker() {
            this.selectedContactIds = [];
            this.isContactPickerVisible = true;
        },
        onPickerShowing() {
            this.selectedContactIds = [];
            if (!this.dsAllContacts || !this.dsMembers) return;

            // Load all current member ContactIDs for exclusion
            this.dsMembers.store().load({
                filter: ['CampanieID', '=', this.campaignId],
                select: ['ContactID']
            }).then((members: any[]) => {
                const existingIds = members.map(m => m.ContactID).filter(id => id);

                const baseFilter: any = [['EmailMarketing', '=', true], 'or', ['SmsMarketing', '=', true]];

                if (existingIds.length > 0) {
                    // Create exclusion filter: [ ['ID','<>',id1], 'and', ['ID','<>',id2], ... ]
                    const exclusions: any[] = [];
                    existingIds.forEach((id, index) => {
                        exclusions.push(['ID', '<>', id]);
                        if (index < existingIds.length - 1) {
                            exclusions.push('and');
                        }
                    });

                    this.dsAllContacts.filter([baseFilter, 'and', exclusions]);
                } else {
                    this.dsAllContacts.filter(baseFilter);
                }

                this.dsAllContacts.reload();
            }).catch(err => {
                console.error("Error loading existing members for exclusion:", err);
                // Fallback to base filter if loading IDs fails
                this.dsAllContacts.filter([['EmailMarketing', '=', true], 'or', ['SmsMarketing', '=', true]]);
                this.dsAllContacts.reload();
            });
        },
        async onLaunchCampaign() {
            const result = await confirm("Ești sigur că vrei să lansezi trimiterea pentru această campanie către toți membrii care nu au primit-o încă?", "Confirmare Trimitere");
            if (result) {
                try {
                    await CrmCampaniiMarketing.launchCampaign(this.campaignId);
                    notify("Trimiterea a fost lansată cu succes!", "success", 2000);
                    this.dsMembers.reload();
                } catch (error) {
                    console.error("Error launching campaign:", error);
                    notify("Eroare la lansarea campaniei!", "error", 2000);
                }
            }
        }
    },
    mounted() {
        this.createODataContext();
    },
    watch: {
        campaignId(newId) {
            if (newId && newId !== "") {
                // Un mic artificiu pentru a forța DevExtreme să trimită tipul corect
                this.dsMembers.filter(['CampanieID', '=', newId]);
                this.dsMembers.reload();
            }
        }
    }
});
</script>

<style scoped lang="scss">
.contact-campanii {
    height: 100%;
    padding: 10px;
}

.toolbar-label {
    font-size: 1.25rem;
    font-weight: 800;
    color: #1e3a8a;
    letter-spacing: -0.025em;
}

/* PREMIUM POPUP STYLES */
.premium-popup-header {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 16px 24px;
    background: linear-gradient(90deg, #ff2c21, #ff6a4a);
    color: white;
    margin: -1px;
    border-radius: 8px 8px 0 0;
}

.header-icon-wrapper {
    width: 28px;
    height: 28px;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    backdrop-filter: blur(4px);

    i {
        font-size: 14px;
    }
}

.header-text {
    display: flex;
    flex-direction: column;
}

.header-title {
    font-size: 1rem;
    font-weight: 700;
    letter-spacing: -0.01em;
}

.header-subtitle {
    font-size: 0.8rem;
    opacity: 0.85;
    font-weight: 400;
}

.picker-main-container {
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 8px;
}

.picker-grid-wrapper {
    flex: 1;
    background: #f8fafc;
    border-radius: 12px;
    padding: 4px;
    border: 1px solid #e2e8f0;
}

/* MODERN GRID CUSTOMIZATIONS */
.modern-grid {
    background: transparent !important;

    :deep(.dx-datagrid-headers) {
        background: transparent;
        color: #64748b;
        font-weight: 600;
        text-transform: uppercase;
        font-size: 0.6rem;
        letter-spacing: 0.05em;
    }

    :deep(.dx-datagrid-rowsview .dx-row) {
        background: white;
        transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);

        &.dx-row-focused,
        &.dx-selection {
            background-color: #eff6ff !important;
        }

        &:hover {
            background-color: #f1f5f9;
        }
    }
}

.picker-contact-cell {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 4px 0;
}

.contact-avatar-small {
    width: 36px;
    height: 36px;
    background: linear-gradient(135deg, #3b82f6 0%, #1e40af 100%);
    color: white;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.75rem;
    font-weight: 700;
}

.contact-name-info {
    display: flex;
    flex-direction: column;

    .primary-name {
        font-weight: 600;
        color: #1e293b;
        font-size: 0.9375rem;
    }

    .secondary-info {
        font-size: 0.75rem;
        color: #64748b;
    }
}

.company-cell-info {
    display: flex;
    align-items: center;
    gap: 8px;
    color: #475569;

    i {
        font-size: 16px;
        opacity: 0.7;
    }
}

.mkt-consent-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
}

/* FOOTER STYLES */
.picker-footer-modern {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 4px 4px 4px;
    border-top: 1px solid #e2e8f0;
    margin-top: 12px;
}

.selection-info {
    flex: 1;
}

.selection-pill {
    display: inline-flex;
    align-items: center;
    background: #10b981;
    color: white;
    padding: 6px 16px;
    border-radius: 20px;
    font-size: 0.875rem;
    font-weight: 600;
    box-shadow: 0 4px 12px rgba(16, 185, 129, 0.2);
}

.animate-in {
    animation: slideIn 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

@keyframes slideIn {
    from {
        opacity: 0;
        transform: translateY(10px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.no-selection-text {
    font-size: 0.8rem;
    color: #94a3b8;
    font-style: italic;
}

.footer-buttons {
    display: flex;
    gap: 12px;
}

.modern-btn {
    border-radius: 8px !important;
    padding: 6px 16px !important;
    font-weight: 600 !important;
    font-size: 0.75rem !important;
    transition: all 0.2s !important;

    &:hover {
        transform: translateY(-1px);
    }
}

.primary-btn {
    box-shadow: 0 4px 12px rgba(16, 185, 129, 0.2);
}

.contact-cell {
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.contact-name {
    font-weight: 600;
}

.status-badge-0 {
    background: #e0f2fe;
    color: #0369a1;
    padding: 4px 12px;
    border-radius: 6px;
    font-weight: 600;
    font-size: 0.75rem;
}

.status-badge-1 {
    background: #dcfce7;
    color: #15803d;
    padding: 4px 12px;
    border-radius: 6px;
    font-weight: 600;
    font-size: 0.75rem;
}

.status-badge-2 {
    background: #fee2e2;
    color: #b91c1c;
    padding: 4px 12px;
    border-radius: 6px;
    font-weight: 600;
    font-size: 0.75rem;
}
</style>
